<template>
  <ExActionsPopUp
    :value="show"
    headline="Unarchive Department"
    :icon="'department_icon'"
    :htmlInfo="info"
    :destructive="false"
    actionLabel="Unarchive"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="handleUnarchive"
    @input="$emit('onClose')"
    data-testid="unarchive-department-popup"
    :applyBorderClass="true"
    :width="450"
    :orgObjectType="'Department'"
    :errorMessage="errorMessage"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["onUnarchive", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 414px; margin: 0 auto; margin-top: 26px;">Department ${props.name} is about to be unarchived.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});

const handleUnarchive = (updatedName) => {
  emit("onUnarchive", updatedName);
};
</script>
